export const detectEnvironment = () => {
  if (typeof window !== 'undefined') {
    const url = window.location.href;

    if (url.includes('.stage.tento.co') || url.includes('.stage.tento.com')) {
      return 'stage';
    } else if (url.includes('.dev.tento.co') || url.includes('.dev.tento.com')) {
      return 'dev';
    } else if ((url.includes('.tento.co') || url.includes('.tento.com')) && !url.includes('local')) {
      return 'production';
    } else if (url.includes('localhost')) {
      return 'local';
    }
  }
  return 'unknown';
};
